import React, { Component } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';

import {GetUser, GetDashboard, GetChatPerson} from '../actions/index';

class Dashboard extends Component {
    constructor(props){
        super(props);
        this.renderPerson = this.renderPerson.bind(this);
    }
    componentDidMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetUser(token);
        this.props.GetDashboard(token);
        this.props.GetChatPerson(token);
    }
    renderPerson(){
        return this.props.chat.personsList.results.map((item, i)=>{
            return (
                <div className="dashboard-block-separator" key={i+1}>
                    <div className="icon-mid-blue">
                        <span className="glyphicon glyphicon-user" aria-hidden="true"></span>
                    </div>
                    <p className="dashboard-title"><Link to={"chat/persons/edit/"+item.id} activeClassName="active" className="">{item.name}</Link></p>
                </div>
            )
        })

    }
    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <p className="dashboard-title">Hi, {this.props.user.user_detail ? <span>{this.props.user.user_detail.first_name} {this.props.user.user_detail.last_name}</span>: ''}</p>
                    <div>
                        <div className="col-md-6">
                            <div className="white-block block-large">
                                <div className="icon-large-white">
                                    <span className="glyphicon glyphicon-book" aria-hidden="true"></span>
                                </div>
                                <p className="dashboard-title">Languages</p>
                                <p className="for_dashboard">{this.props.dashboard ? <span>{this.props.dashboard.flangs}</span> : ''} learning languages</p>
                                <p className="for_dashboard">{this.props.dashboard ? <span>{this.props.dashboard.blangs}</span> : ''} interface languages</p>
                                <Link to="language" className="btn btn-primary">View all languages</Link>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="white-block block-large">
                                <div className="icon-large-white">
                                    <span className="glyphicon glyphicon-user" aria-hidden="true"></span>
                                </div>
                                <p className="dashboard-title">Users</p>
                                <p className="for_dashboard">{this.props.dashboard ? <span>{this.props.dashboard.users}</span> : ''} users</p>
                                <p className="for_dashboard">{this.props.dashboard ? <span>{this.props.dashboard.subscriptions}</span> : ''} active subscriptions users</p>
                                <Link to="users" className="btn btn-primary">View all users</Link>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <p className="dashboard-title">Subscription</p>
                            <div className="white-block">
                                <div className="dashboard-block-separator">
                                    <div className="icon-mid-blue">
                                        <span className="glyphicon glyphicon-credit-card" aria-hidden="true"></span>
                                    </div>
                                    <p className="dashboard-title"><Link to={"subscription"} activeClassName="active" className="">Billing</Link></p>
                                </div>
                                <div className="dashboard-block-separator">
                                    <div className="icon-mid-blue">
                                        <span className="glyphicon glyphicon-tag" aria-hidden="true"></span>
                                    </div>
                                    <p className="dashboard-title"><Link to={"subscription/coupons"} activeClassName="active" className="">Coupon</Link></p>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <p className="dashboard-title">Chat</p>
                            <div className="white-block">
                                {this.props.chat.personsList && this.props.chat.personsList.results ? this.renderPerson() : ''}
                                <div className="clearfix"></div>
                            </div>
                        </div>

                    </div>
                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        user: state.user,
        dashboard: state.dashboard,
        chat: state.chat
    }
}
export default connect(mapStateToProps, {GetUser, GetDashboard, GetChatPerson})(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard.js